__turbopack_context__.v({
  "ProductHighlightItem": "SRrnBG_ProductHighlightItem",
  "ProductHighlightItem__Button": "SRrnBG_ProductHighlightItem__Button",
  "ProductHighlightItem__ButtonText": "SRrnBG_ProductHighlightItem__ButtonText",
  "ProductHighlightItem__Container": "SRrnBG_ProductHighlightItem__Container",
  "ProductHighlightItem__Description": "SRrnBG_ProductHighlightItem__Description",
  "ProductHighlightItem__DescriptionTextWrapper": "SRrnBG_ProductHighlightItem__DescriptionTextWrapper",
  "ProductHighlightItem__DescriptionWrapper": "SRrnBG_ProductHighlightItem__DescriptionWrapper",
  "ProductHighlightItem__Image": "SRrnBG_ProductHighlightItem__Image",
  "ProductHighlightItem__LogoImageWrapper": "SRrnBG_ProductHighlightItem__LogoImageWrapper",
  "ProductHighlightItem__ProductImage": "SRrnBG_ProductHighlightItem__ProductImage",
  "ProductHighlightItem__ProductImage--Loaded": "SRrnBG_ProductHighlightItem__ProductImage--Loaded",
  "ProductHighlightItem__ProductImageWrapper": "SRrnBG_ProductHighlightItem__ProductImageWrapper",
});
